
const LocationIcon = ({
    color = '#000',
    fondo = '#fff',
    vetor_css = { fontSize: '50px' },
    main_css = { width: '40px', padding: '0px' }
}) => {

    return (
        <svg class="img-fluid" id="outputsvg" xmlns="http://www.w3.org/2000/svg" style={main_css} width="512" viewBox="0 0 5120 5120">
            <g id="l3wWrgyVC3T2htiwuezLU2" fill={color}>
                <g>
                    <path id="p1GucsgxOg" d="M2531 5110 c-18 -5 -46 -21 -62 -37 -39 -39 -1438 -2331 -1514 -2478 -129 -253 -185 -496 -185 -801 -1 -480 181 -916 524 -1260 347 -346 779 -525 1271 -525 478 0 902 173 1248 510 381 371 575 882 536 1411 -19 256 -101 536 -212 729 -39 67 -1410 2326 -1440 2372 -44 69 -98 94 -166 79z m206 -2426 c189 -39 318 -109 458 -249 181 -181 265 -383 265 -635 0 -245 -90 -461 -265 -635 -176 -177 -390 -265 -640 -265 -248 0 -453 86 -631 264 -180 180 -264 383 -264 638 0 159 28 275 96 411 119 235 353 416 609 470 94 21 277 21 372 1z">
                    </path>
                </g>
            </g>
        </svg>

    )
}

export default LocationIcon;